import React, { useEffect, useState } from "react";
import Stripe from "stripe";
import getPublishableKey from '../../stripe/publishableKey';
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

const stripe_publishable_key = getPublishableKey()
// const stripe_secret_key = getSecretKey()
const stripePromise = loadStripe(stripe_publishable_key)
// const stripe = Stripe(stripe_secret_key)

const Dashboard = (props) => {
    const {planName, cancelarSuscripcion, conectarStripe, isStripeUser, conectandoStripe, balance} = props;

    return (
        <div className="dashboard">
            {
                !isStripeUser &&
                    <div className="dashboard-top-plan stripe-connect-content">

                        <p>Conecta su cuenta con <b>Stripe</b> para poder recibir pagos. {isStripeUser}</p>
                        <div className="button" onClick={conectarStripe}>
                            { conectandoStripe ? 'Conectando...' : 'Conectar' }
                        </div>
                    </div>
            }
            <div className="dashboard-body">
                <div className="dashboard-top-plan">
                    <p>Actualmente dispone del <b>{planName}</b>.</p>
                    <div className="button borrarCuenta" onClick={cancelarSuscripcion}>Cancelar suscripción</div>
                </div>
            </div>
            {
                isStripeUser && balance && 
                <div className="dashboard-content-top d-flex justify-content-end">
                    <p class="balance">
                        {balance} €
                    </p>
                </div>
            }
        </div>
    );
}

export default Dashboard;